import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import booking from '@/modules/booking/store'
import settings from '@/modules/settings/store'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    booking,
    settings
  },
  getters: {
    ...getters,
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js